
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/veranstaltungen/[filter]",
      function () {
        return require("private-next-pages/veranstaltungen/[filter].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/veranstaltungen/[filter]"])
      });
    }
  